import script from "./IncomeAndPots.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncomeAndPots.vue?vue&type=script&setup=true&lang=ts"

import "./IncomeAndPots.vue?vue&type=style&index=0&id=2dc93207&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc93207"]])

export default __exports__